import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';
import { makeStyles, Typography, Box } from '@material-ui/core';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import {
  parseCostHistory,
  latestMonth,
  totalForMonth,
  formatUsd,
} from './parseCostHistory';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing(1, 0),
  },
  amount: {
    fontSize: '2rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  month: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  icon: {
    color: theme.palette.text.secondary,
    fontSize: '1.2rem',
    verticalAlign: 'middle',
    marginRight: theme.spacing(0.5),
  },
}));

export const CostSummaryCard = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const data = parseCostHistory(entity.metadata.annotations as Record<string, string>);

  if (!data) return null;

  const month = latestMonth(data);
  if (!month) return null;

  const total = totalForMonth(data[month]);

  const monthLabel = new Date(`${month}-01`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  });

  return (
    <InfoCard title="Monthly Cost" deepLink={{ title: 'View cost history', link: 'cost-history' }}>
      <Box className={classes.root}>
        <Typography className={classes.amount}>
          <TrendingUpIcon className={classes.icon} />
          {formatUsd(total)}
        </Typography>
        <Typography variant="body2" className={classes.month}>
          {monthLabel}
        </Typography>
      </Box>
    </InfoCard>
  );
};
